import React, { useState } from "react";
import { DatePicker, Button, Space, Card, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import useApis from "../apis/useApis";
import appConstant from "../json/appConstant.json";
import moment from 'moment';

const { RangePicker } = DatePicker;

const SurveyFilter = ({ onSearch, isDarkMode, onDataReceived }) => {
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(false);
  const { jsonApi } = useApis();

  const handleSearch = async () => {
    const [startDate, endDate] = dates || [];
    if (!startDate || !endDate) {
      message.warning("Please select both start and end dates");
      return;
    }

    setLoading(true);
    try {
      const formattedStartDate = startDate.format("YYYY-MM-DD");
      const formattedEndDate = endDate.format("YYYY-MM-DD");

      // Update parent component with date filter state
      onSearch?.({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });

      // Fetch filtered data to check if it's empty
      const response = await jsonApi(
        appConstant.surveyData,
        {
          startDate: formattedStartDate,
          endDate: formattedEndDate
        },
        null,
        null
      );

      if (response?.data?.code === 200 && response?.data?.status === "success") {
        if (response.data.data.surveys.length === 0) {
          message.error('No Data Found');
        } else {
          message.success('Data Filtered Successfully');
        }
      }
    } catch (error) {
      console.error("Error in date filter:", error);
      message.error("Failed to apply date filter");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDates(null);
    onSearch?.({ startDate: null, endDate: null });
    // Trigger normal users API fetch
    onDataReceived?.({ data: [], total: 0 });

    // Fetch all survey data when the filter is cleared
    const fetchAllData = async () => {
      const response = await jsonApi(appConstant.surveyData, {}, null, null);
      if (response?.data?.code === 200 && response?.data?.status === "success") {
        const mappedData = {
          data: response.data.data.surveys.map((survey) => ({
            key: survey.id,
            id: survey.id,
            name: survey.name,
            guardian_name: survey.guardian_name,
            phone_no: survey.phone_no,
            building_rent: survey.building_rent,
            construction_year: survey.construction_year,
            house_tax: survey.house_tax,
            created_at: survey.created_at,
          })),
          total: response.data.data.totalSurveys
        };
        onDataReceived?.(mappedData);
      }
    };

    fetchAllData();
  };

  const handleDateChange = (values) => {
    setDates(values);
    if (!values) {
      handleClear();
    }
  };

  return (
    <Card
      style={{
        
        background: isDarkMode ? "#1f1f1f" : "#ffffff",
        borderColor: isDarkMode ? "#303030" : "#f0f0f0",
        padding: 0 , // 👈 Remove Card padding
        // top: 15

      }}
    >
      <Space size="middle" style={{padding:0}}>
        <RangePicker
          style={{ width: "250px"}}
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          placeholder={["Start Date", "End Date"]}
          value={dates}
          allowClear={true}
          disabledDate={(current) => current && current > moment().endOf("day")}

        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={loading}
        >
          Search
        </Button>
      </Space>
    </Card>
  );
};

export default SurveyFilter;
